import React, {useEffect} from 'react';
import {Grid} from '@mui/material';
import {makeStyles} from "@mui/styles";

import 'react-datepicker/dist/react-datepicker.css';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

import {insertZeroTo} from '../../lib/'

am4core.useTheme(am4themes_animated);
const useStyles = makeStyles(() => ({
  chartBox: {
    height:240,
  }
}));

export default function ChartValue(props: any) {
  const { chartName, standard, data, type, totalValue } = props;
  const classes = useStyles();
  const d = new Date();
  const dayCount = new Date(d.getFullYear(),d.getMonth() + 1,0).getDate()
  function initData(data: any): any {
    let filteredData: any = [];

    for (let i = 1, j = 0; i <= dayCount; i++) {
      if (d.getFullYear() + "-" + insertZeroTo(d.getMonth() +1) + "-" + insertZeroTo(i) === data[j]?.departureDate) {
        data[j].index = i;
        filteredData.push(data[j]);
        j++;
      }
      else{
        filteredData.push({
          departureDate: d.getFullYear() + "-" + insertZeroTo(d.getMonth() +1) + "-" + insertZeroTo(i),
          count: 0,
          charge: 0,
          index: i
        })
      }
    }

    return filteredData;
  }

  function drawChart(filterData: any) {
    let chart = am4core.create(props.chartName, am4charts.XYChart);
    chart.data = filterData
    chart.padding(40, 0, 40, 0);

    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = "index";
    categoryAxis.renderer.minGridDistance = 20; //전체 날짜 표기
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.labels.template.fill = am4core.color("#d3d3d3");
    categoryAxis.renderer.labels.template.fontSize = 16

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0; // Y축 최소값 0으로 세팅

    if(totalValue < 1) standard === "건" ? valueAxis.max = 20 : valueAxis.max = 1000000; // value가 0건으로 넘어올 경우Y축 최대값 세팅

    valueAxis.maxPrecision = 0; // Y축 표기단위 정수만 가능하도록 세팅
    valueAxis.renderer.minGridDistance = 40  // Y축 단위표기

    if (valueAxis.tooltip) valueAxis.tooltip.disabled = true;
    valueAxis.renderer.labels.template.fill = am4core.color("#bdbdbd"); // Y축 글자색

    let series = new am4charts.ColumnSeries()
    series.columns.template.events.on("over",(e) =>{
      e.target.column.fill = am4core.color("#009340");
    })
    series.columns.template.events.on("out",(e) => {
      e.target.column.fill = am4core.color("#cce9d9");
    })
    series.fill = am4core.color("#cce9d9");
    series.dataFields.categoryX = "index";
    series.dataFields.valueY = type;
    series.tooltipText = "{valueY.value}"+standard;
    series.columns.template.strokeOpacity = 0;
    series.columns.template.width = am4core.percent(40)

    if (series.tooltip) {
      series.tooltip.background.stroke = am4core.color("gray");//툴팁 테두리 색상
      series.tooltip.getFillFromObject = false;//툴팁 배경 색상
      series.tooltip.background.fill = am4core.color("#FFFFFF");//툴팁 내부 글자 색상
      series.tooltip.autoTextColor = false;
      series.tooltip.label.fill = am4core.color("#000000");
      series.tooltip.pointerOrientation = "vertical";//툴팁 위에 뜨도록.
    }

    //border Radius Setting
    series.columns.template.column.cornerRadiusTopRight = 40;
    series.columns.template.column.cornerRadiusTopLeft = 40;
    series.columns.template.column.cornerRadiusBottomLeft = 40;
    series.columns.template.column.cornerRadiusBottomRight = 40;

    chart.series.push(series);
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.lineY.disabled = true;
    chart.cursor.lineX.disabled = true;
    if (chart.tooltip) chart.tooltip.getFillFromObject = false;
  }

  useEffect(() => {
    const filterData = initData(data)
    drawChart(filterData)
  }, [data])

  return (
    <>
      <Grid container direction={"column"}>
        <Grid item>
          <div id={chartName} className={classes.chartBox}> </div>
        </Grid>
      </Grid>
    </>
  )
}